import React from 'react'
import { HeaderData } from './ReturnsCreateReturn'
import { Chip, Grid } from '@mui/material'
import { ViewItem } from '../ViewItem/ViewItem'
import { utcToLocal } from '../../utils/dateHelper'

interface CreateReturnHeaderProps {
  headerData: HeaderData
}

export const CreateReturnHeader: React.FC<CreateReturnHeaderProps> = ({
  headerData
}) => {
  return (
    <Grid container item xs={12}>
      <Grid item xs={6} sm={2}>
        <ViewItem dense title='OT' text={headerData.workOrderId.toString()} />
      </Grid>
      <Grid item xs={6} sm={2}>
        <ViewItem
          dense
          title='Despacho'
          text={utcToLocal(headerData.dispatchedDate, 'dd/MM/yyyy HH:mm:ss')}
        />
      </Grid>
      <Grid item xs={6} sm={2}>
        <ViewItem
          dense
          title='Unidades'
          text={headerData.totalUnits.toString()}
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <ViewItem dense title='SKUs' text={headerData.skuQuantity.toString()} />
      </Grid>
      <Grid item xs={6} sm={3}>
        <ViewItem dense title='IDs Externos' text={''} />
        {headerData.externalOrderId.map((order) => (
          <Chip color='default' key={order} label={order} />
        ))}
      </Grid>
    </Grid>
  )
}
